// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IncidentStatus } from './IncidentStatus';
import {
    IncidentStatusFromJSON,
    IncidentStatusFromJSONTyped,
    IncidentStatusToJSON,
    IncidentStatusToJSONTyped,
} from './IncidentStatus';

/**
 * 
 * @export
 * @interface IncidentHistory
 */
export interface IncidentHistory {
    /**
     * UUID of the updated incident
     */
    incidentId: string;
    /**
     * 
     */
    updatedAt: Date;
    /**
     * 
     */
    status: IncidentStatus;
    /**
     * Indicates who or what initiated the status update
     */
    origin?: IncidentHistoryOriginEnum;
    /**
     * Id of the user/device that initiated the status update
     */
    originId?: string;
    /**
     * The event's message — for ack/confirm/reset events this is the operator-supplied comment; for alarm-state events it's the condition message ("Condition is X and state is HighHigh"). Empty when the source event had no message.
     * 
     */
    message?: string | null;
    /**
     * Set on synthetic entries that aggregate a run of adjacent NEW/RESOLVED transitions (alarm value oscillating around its threshold). When present, this single row represents `flapCount` collapsed source events; `updatedAt` is the newest of the run and `flapStartedAt` is the oldest. Absent on regular entries.
     * 
     */
    flapCount?: number;
    /**
     * Timestamp of the oldest event in a collapsed flap-run. Only set together with `flapCount`.
     * 
     */
    flapStartedAt?: Date;
}


/**
 * @export
 */
export const IncidentHistoryOriginEnum = {
    Source: 'source',
    User: 'user',
    Service: 'service'
} as const;
export type IncidentHistoryOriginEnum = typeof IncidentHistoryOriginEnum[keyof typeof IncidentHistoryOriginEnum];


/**
 * Check if a given object implements the IncidentHistory interface.
 */
export function instanceOfIncidentHistory(value: object): value is IncidentHistory {
    if (!('incidentId' in value) || value['incidentId'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function IncidentHistoryFromJSON(json: any): IncidentHistory {
    return IncidentHistoryFromJSONTyped(json, false);
}

export function IncidentHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentHistory {
    if (json == null) {
        return json;
    }
    return {
        
        'incidentId': json['incidentId'],
        'updatedAt': (new Date(json['updatedAt'])),
        'status': IncidentStatusFromJSON(json['status']),
        'origin': json['origin'] == null ? undefined : json['origin'],
        'originId': json['originId'] == null ? undefined : json['originId'],
        'message': json['message'] === undefined ? undefined : json['message'] === null ? null : json['message'],
        'flapCount': json['flapCount'] == null ? undefined : json['flapCount'],
        'flapStartedAt': json['flapStartedAt'] == null ? undefined : (new Date(json['flapStartedAt'])),
    };
}

export function IncidentHistoryToJSON(json: any): IncidentHistory {
    return IncidentHistoryToJSONTyped(json, false);
}

export function IncidentHistoryToJSONTyped(value?: IncidentHistory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'incidentId': value['incidentId'],
        'updatedAt': value['updatedAt'].toISOString(),
        'status': IncidentStatusToJSON(value['status']),
        'origin': value['origin'],
        'originId': value['originId'],
        'message': value['message'],
        'flapCount': value['flapCount'],
        'flapStartedAt': value['flapStartedAt'] == null ? value['flapStartedAt'] : value['flapStartedAt'].toISOString(),
    };
}

